/** @jsxImportSource @emotion/react */

import React from 'react';
import { useTypedDispatch } from '@hook/common/useStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { actions as navigationActions } from '@store/slice/navigation-slice';
import PageTemplate from '@page/iyagigo/page-template';
import Statistic from '@component/iyagigo/studio/statistic';
import Scroll from '@component/common/scroll';

const StatisticPage: React.FC<any> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useTypedDispatch();

  return (
    <PageTemplate
      title={'학습통계'}
      mode={'back'}
      handleNavigationClick={() => {
        navigate(IYAGIGO_PATH.STUDIO_HOME_PATH);
      }}>
      <Scroll direction='y' height={`calc(100% - 10px)`}>
        {<Statistic />}
      </Scroll>
    </PageTemplate>
  );
};

export default StatisticPage;
